<template>
  <v-app-bar app clipped-left clipped-right :color="color" :dark="dark">
    <slot name="left-side" />

    <v-spacer></v-spacer>

    <slot name="right-side" />
  </v-app-bar>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
